// extracted by mini-css-extract-plugin
module.exports = {"body":"Embed_body__1PThM","timeout":"Embed_timeout__vh30e","overlay":"Embed_overlay__1mUeY"};